/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'renewal/h1': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M12.483 18.064h-2.091v-5.37H4.988v5.37h-2.1V5.978h2.1v5.03h5.404v-5.03h2.091v12.086zM21.112 18.064h-2.009V8.36L16.14 9.373V7.67l4.715-1.735h.257v12.128z" _fill="currentColor"/>'
  }
})
